import { Redirect } from 'react-router-dom'

export default function RegisterSuccess() {
  return <Redirect to="/farms?rs=1" />
}
